/**
 * Created by crisan on 12/12/16.
 */

/// <reference path="Client_ManagedObject.ts" />

class Client extends Client_ManagedObject
{
    // NOTE: "agent" is not a datamodel relationship; DBClientsCoder assigns a Contact to it
    // as a plain (non-persisted) property.
    agent: Contact;
}